module.exports = __webpack_public_path__ + "img/antracyt.e1371b93.jpg";